import { Button, Tooltip } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import AddIcon from "@mui/icons-material/Add";

import { usePageSettings } from '../../contexts/PageSettingsContext';
import {useKeyMomentActiveFilters} from "../../contexts/application/KeyMomentActiveFilters";
import {useClipActiveFilters} from "../../contexts/application/ClipActiveFilters";
import { iconBadgeSx, iconBadgeHoverSx } from "../../styles/iconHover";

export default function CreateCollectionButton({clip_type, flagIcon = false, redirectHome = false, flagDisabled = true, handleCreate = () => {}}) {
    const navigate = useNavigate()
    const {setCreateMode} = usePageSettings()
    const {resetKeyMomentActiveOption} = useKeyMomentActiveFilters();
    const {resetClipActiveOption} = useClipActiveFilters()

    const handleCreateCollection = () => {
        if(redirectHome) {
            setCreateMode(true)
            resetKeyMomentActiveOption()
            resetClipActiveOption()
            navigate(location.pathname+'/newcollection')
        }
        else { handleCreate() }
    }

    return (
        <Tooltip placement='top' title={'Create a collection of '+(String(clip_type).toLowerCase().replace('_',' '))}>
            <Button
                data-tour={"new_collection_button"}
                disabled={flagDisabled}
                onClick={() => handleCreateCollection()}
                startIcon={
                    flagIcon ? (<AddIcon
                    className="add-icon"
                    sx={iconBadgeSx({ size: 20, color: "black" })}
                    />): null
                }
                sx={{
                    height:'30px',
                    paddingInline: 1,
                    backgroundColor: "#1e1e1e",
                    color: "white",
                    borderRadius: 6,
                    border: "1px solid white",
                    "&:hover": {
                        backgroundColor: "#4d4d4dff",
                        color: "#fff",
                        ...iconBadgeHoverSx(),
                    }
                }}
            >
                {'New Collection'}
            </Button>
        </Tooltip>
    )
}